var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Platform, View } from 'react-native';
import { ShellView } from '../../Components/Common/ShellView';
import { BaseScreenComponent } from '../BaseScreen/BaseScreenComponent';
import { Shadow } from '../../Styles/Shadow';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { getScreenOffset } from '../../Hooks/UseOrientation';
import { useColorScheme } from '../../Hooks/UseColorScheme';
import { useDirection } from '../../Hooks/UseDirection';
export const ModalScreenView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.modalScreen,
    style(theme, mediaQuery, window, props) {
        return {
            modal: Object.assign({}, props.modalStyle),
            container: Object.assign({ marginTop: -getScreenOffset().value.top, flex: 1, padding: 0 }, props.containerStyle),
            shellContent: Object.assign(Object.assign(Object.assign({ padding: 0 }, mediaQuery.md({
                padding: 20
            })), { alignItems: 'center', justifyContent: 'center' }), props.shellStyle),
            content: Object.assign(Object.assign(Object.assign({ flex: 1, width: '100%', height: '100%' }, !props.headerTransparent && {
                paddingTop: Platform.select({
                    default: getScreenOffset().value.top,
                    android: getScreenOffset().value.top + 20,
                    ios: getScreenOffset().value.top + 20
                })
            }), { paddingBottom: getScreenOffset().value.bottom }), mediaQuery.md(Object.assign(Object.assign({ flex: undefined, height: undefined, borderRadius: 8 }, Shadow.level(1)), { overflow: 'hidden' }))),
        };
    }
})((_a) => {
    var { style, children, shellSize, presentation, hideBackButton, hideHeader, onDismiss, navigation } = _a, otherProps = __rest(_a, ["style", "children", "shellSize", "presentation", "hideBackButton", "hideHeader", "onDismiss", "navigation"]);
    const color_scheme = useColorScheme();
    const [dir] = useDirection();
    if (Platform.OS !== 'web') {
        return (_jsx(BaseScreenComponent, Object.assign({ navigation: navigation, hideHeader: hideHeader, hideBackButton: hideBackButton, presentation: presentation, reverseHeader: true, isDismissButton: true, forceCanBack: true, onDismiss: onDismiss }, otherProps, { children: children })));
    }
    return (_jsx(Modal, Object.assign({ style: style === null || style === void 0 ? void 0 : style.modal, transparent: true, statusBarTranslucent: true, visible: true, animationType: 'fade' }, dir === 'rtl' && { dir: 'rtl' }, { children: _jsx(ShellView, { shellContentStyle: style === null || style === void 0 ? void 0 : style.shellContent, containerStyle: style === null || style === void 0 ? void 0 : style.container, size: shellSize || 'md', children: _jsx(View, { style: [style === null || style === void 0 ? void 0 : style.content, { backgroundColor: color_scheme.colors.background }], children: _jsx(BaseScreenComponent, Object.assign({ reverseHeader: true, isDismissButton: true, forceCanBack: true, presentation: "transparentModal", hideBackButton: hideBackButton, onDismiss: onDismiss, navigation: navigation, hideHeader: hideHeader }, otherProps, { children: children })) }) }) })));
});
